import React, { useState, useEffect } from 'react';
import { HiMenuAlt4, HiX,HiMoon,HiOutlineLightBulb } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Navbar.scss';

const Navbar = (props) => {
  const { theme, onChangeValue } = props
  const [toggle, setToggle] = useState(false)
  const [menuItems, setMenuItems] = useState(
    ['About',
    'Experience',
    'Projects', 
    'Activities',
    "Academics", 
    'Blog',
    'Testimonial',
    'Contact'
  ])
  return (
    <nav className="app__navbar">
      <ul className="app__navbar-links">
        {menuItems.map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <Link to={`/#${item.toLowerCase()}`}>{item}</Link>
          </li>
        ))}
        <li className="app__flex p-text">
          <a >
        {(theme=="dark-mode")?(
        <HiOutlineLightBulb cursor={"pointer"} size={25} onClick={() => {
          onChangeValue( "light-mode")
        }} />
        ):(<HiMoon cursor={"pointer"} size={25} onClick={() => {
          onChangeValue("dark-mode")
          }} />)}
        </a>
          </li>
      </ul>

      <div className="app__navbar-menu">
        <HiMenuAlt4 cursor={"pointer"} onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX cursor={"pointer"} onClick={() => setToggle(false)} />
            <ul>
              {menuItems.map((item) => (
                <li key={item}>
                  <Link to={`/#${item.toLowerCase()}`} onClick={() => setToggle(false)}>
                    {item}
                  </Link>
                </li>
              ))}
              <li>
          <a >
        {(theme=="dark-mode")?(
        <HiOutlineLightBulb cursor={"pointer"} size={25} onClick={() => {
          onChangeValue( "light-mode")
        }} />
        ):(<HiMoon cursor={"pointer"} size={25} onClick={() => {
          onChangeValue("dark-mode")
          }} />)}
        </a>
          </li>
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
